import request from '@/auth/jwt/request'

/**
 * @description 客户预约单 -- 查询列表
 * id = 0 新增
 * @param {Object} param params {Object} 传值参数
 */
export const recommendCustomerListApi = params => { return request('customer-order/list', 'get', params) }

/**
 * @description 客户预约单 -- 审核
 * { id = x }
 */
export const recommendCustomerVerifyApi = data => { return request('customer-order/verify', 'put', {}, data) }

/**
 * @description 客户预约单 --- 项目下拉
 * @param {Object} param params {Object} 传值参数
 */
export const recommendCustomerProjectList = params => { return request('pull-down/projectSelect', 'get', params) }